import TeaserSlider from 'components/organisms/teaser-slider/TeaserSlider';
import { MEDIA_QUERIES } from 'javascripts/constants';
import icon from 'components/_particles/icon/icon';
import h from 'hyperscript';
import { t } from 'javascripts/utils/withTranslation';

class PhaseTimeline extends TeaserSlider {
  constructor($phaseTimeline, mq) {
    super($phaseTimeline, mq, {
      showDots: false,
      scrollContainerClass: '.phase-timeline__inner',
      itemsContainerClass: '.phase-timeline__items',
      itemClass: '.phase-timeline__item',
      resizeVerticalImages: false,
      positionControlsOnImages: false,
    });

    this.$slider = $phaseTimeline;
    this.itemsToScroll = this.getItemsToScroll();
    this.itemsVisible = this.getItemsVisible();
    this.$items = this.$slider?.querySelectorAll('.phase-timeline__item');
    const mqL = window.matchMedia(MEDIA_QUERIES.l);

    if (
      (mqL.matches && this.numberOfSlides > 5) ||
      (!mqL.matches && this.itemsToScroll < this.numberOfSlides)
    ) {
      this.$slider.classList.remove('phase-timeline--no-controls');
      this.$slider.classList.add('phase-timeline--initialized');

      this.initControls();
      super.initEvents();
      this.slideToActiveItem();
    } else {
      this.$slider.classList.add('phase-timeline--no-controls');
      this.$slider.classList.remove('phase-timeline--initialized');
      this.deconstructor();
    }
  }

  slideToActiveItem() {
    const activeIndex = Math.max(
      [...this.$items]?.findIndex((item) =>
        item.classList.contains('phase-timeline__item--active')
      ),
      0
    );
    this.itemsToScroll = this.getItemsToScroll();
    this.itemsVisible = this.getItemsVisible();
    this.maxIndex = this.getMaxIndex();

    if (activeIndex + 1 > this.itemsVisible) {
      const targetIndex = Math.min(
        activeIndex - (activeIndex % this.itemsToScroll),
        this.maxIndex
      );
      this.slideTo(targetIndex);
    }
  }

  getItemsVisible() {
    const mqM = window.matchMedia(MEDIA_QUERIES.m);
    const mqL = window.matchMedia(MEDIA_QUERIES.l);
    const mqXl = window.matchMedia(MEDIA_QUERIES.xl);

    // mobile
    let itemsVisible = 1;

    // tablet
    if (mqM.matches) {
      itemsVisible = 2;
    }

    // tablet landscape
    if (mqL.matches) {
      itemsVisible = 4;
    }

    // tablet landscape or small desktop
    if (mqXl.matches) {
      itemsVisible = 5;
    }

    return itemsVisible;
  }

  getItemsToScroll() {
    const mqM = window.matchMedia(MEDIA_QUERIES.m);
    const mqL = window.matchMedia(MEDIA_QUERIES.l);
    const mqXl = window.matchMedia(MEDIA_QUERIES.xl);

    // mobile
    let itemsToScroll = 1;

    // tablet
    if (mqM.matches) {
      itemsToScroll = 2;
    }

    // tablet landscape
    if (mqL.matches) {
      itemsToScroll = 4;
    }

    // tablet landscape or small desktop
    if (mqXl.matches) {
      itemsToScroll = 1;
    }

    return itemsToScroll;
  }
}

let componentStore = [];
const mql = window.matchMedia(MEDIA_QUERIES.l);

function onMediaQueryChange(mq) {
  componentStore.forEach(
    (component) => component.deconstructor && component.deconstructor()
  );
  componentStore = [];
  const isDesktop = mq.matches;
  const $phaseTs = document.querySelectorAll('.phase-timeline');

  $phaseTs?.forEach(($slider) => {
    const numberOfItems = $slider.querySelectorAll(
      '.phase-timeline__item'
    ).length;
    const isMinimal = $slider.classList.contains('phase-timeline--minimal');
    if (
      ((isDesktop && numberOfItems > 5) || (!isDesktop && numberOfItems > 1)) &&
      !isMinimal
    ) {
      componentStore.push(new PhaseTimeline($slider, mq));
    } else {
      $slider.classList.add('phase-timeline--no-controls');
    }
  });
}

mql.addListener(onMediaQueryChange);
onMediaQueryChange(mql);
